// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"27f5ab31","2423":"f7b97fce"}[chunkId] + ".chunk.css";
};